import Error from '@components/Error'
import PageTitle from '@components/PageTitle'
import { StoreProps } from '@interfaces/StoreState'
import { PAGE, SALESFORCE_ROLE_LABEL, SF_STANDARD_ROLE, SF_STANDARD_ROLE_LABEL } from '@utils/constants'
import { getQueryParams } from '@utils/helpers'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import AvailabilityWrapper from './Availability/AvailabilityWrapper'
import { CrossInstrcutorProvider, FMIStudentProfileProvider } from './context'
import InstructorsWrapper from './InstructorsWrapper'
import InstructorProfileWrapper from './Profile/ProfileWrapper'
import PageOverlay from '@components/PageOverlay'

export const RegionalUserDashboard: React.FC<{ baseRoute: string }> = ({ baseRoute }) => {
  const sid = getQueryParams('sid')
  const path = getQueryParams('path')
  const ie = getQueryParams('ie')
  const d = getQueryParams('d')
  const lc = getQueryParams('lc')
  const tz = getQueryParams('tz')
  const router = useRouter()

  useEffect(() => {
    if (sid) {
      let route = baseRoute

      if (baseRoute?.includes('sfstandard') && path === PAGE.PATHS.STUDENT_PROGRESS.id) {
        route = PAGE.PATHS.STUDENT_PROGRESS.SFStandardURL
      }

      router.push(`${route}/?sid=${sid}${path ? `&path=${path}` : ''}`, undefined, { shallow: true })
    }

    if (ie) {
      router.push(`/sfstandard/availability/?ie=${ie}`)
    }

    if (d && lc && tz) {
      router.push(`/sfstandard/lc-calendar/?d=${d}&lc=${lc}&tz=${tz}`)
    }
  }, [sid, ie, lc, d, tz, path])

  if (sid || ie || (d && lc && tz)) {
    return <PageOverlay />
  }

  return <Error statusCode={403} />
}

export const PageWrappers: React.FC<{ title: string; Component: React.ReactNode }> = ({ title, Component }) => {
  const intl = useIntl()
  const UserRole = useSelector(({ session }: StoreProps) =>
    session?.cognitoGroups?.includes(SF_STANDARD_ROLE) ? SF_STANDARD_ROLE_LABEL : SALESFORCE_ROLE_LABEL
  )

  return (
    <>
      {getQueryParams('sid') ? (
        <FMIStudentProfileProvider studentId={getQueryParams('sid')} isAdmin>
          <PageTitle title={`${intl.formatMessage({ id: title, defaultMessage: title })} | ${UserRole}`} />
          <CrossInstrcutorProvider>{Component}</CrossInstrcutorProvider>
        </FMIStudentProfileProvider>
      ) : (
        <Error statusCode={404} />
      )}
    </>
  )
}

export const FMIInstructors: React.FC = () => <PageWrappers title={'Instructors'} Component={<InstructorsWrapper />} />

export const FMIInstructorProfile: React.FC = () => (
  <PageWrappers title={'Instructor Profile'} Component={<InstructorProfileWrapper />} />
)

export const FMIInstructorAvailability: React.FC = () => (
  <PageWrappers title={'Instructor Availability'} Component={<AvailabilityWrapper />} />
)
